import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppClientConfigurationService, TranslationService } from '@sdbn/common';
import { combineLatest } from 'rxjs';
import { Language, languages } from '../../../../common/configuration/countries.configuration';


@Component({
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommunicationLanguageFieldComponent),
      multi: true,
    },
  ],
  selector: 'app-communication-language-field',
  templateUrl: './communication-language-field.component.html',
  styleUrls: ['./communication-language-field.component.scss']
})
export class CommunicationLanguageFieldComponent implements OnInit, ControlValueAccessor {

  @Input() label!: string;

  @Input() required: boolean = false;

  @Input() showOthersOption: boolean = false;

  @Input('limitCountries') set setLimitCountries(value: Array<string>) {

  }

  public readonly formControl = new FormControl(null, []);

  availableLanguages = languages;

  constructor(
    public translationService: TranslationService,
    private cps: AppClientConfigurationService,
  ) {}

  public ngOnInit(): void {

    let configuredLanguagesValue = this.cps.getPropertyValue("tmc-yard.messaging.allowed-languages");
    const configuredLanguages = configuredLanguagesValue.split("|");

    configuredLanguages.sort((a, b) => {
      const ta = this.translationService.translate('common.enum.language.' + a);
      const tb = this.translationService.translate('common.enum.language.' + b);
      return ta > tb ? 1 : ta === tb ? 0 : -1;
    });

    let availableLanguages = new Array<Language>();

    for (let language of configuredLanguages) {
      languages.filter(l => l.key === language).forEach(element => {
        availableLanguages.push(element);
      });
    }

    this.availableLanguages = availableLanguages;

    combineLatest([
      this.formControl.valueChanges
    ]).subscribe(() => {
      const value = this._getValue();
      this._onChange(value);
    });
  }

  /** Return a Date if the fields are ready or null otherwise */
  private _getValue(): number | null {
    try {
      if (this.formControl.invalid) {
        return null;
      }

      return this.formControl.value;
    } catch {
      // Return null if something throws
      return null;
    }
  }

  public writeValue(value: number | null): void {
    if (value != null) {
      this.formControl.setValue(value);
    } else {
      this.formControl.setValue(null);
    }
  }

  private _onChange = (_value: number | null): void => undefined;
  public registerOnChange(fn: (value: number | null) => void): void {
    this._onChange = fn;
  }

  /** It's called in the component template when we have a "blur" or "input" event */
  public onTouched = (): void => undefined;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

}
